import React from 'react';

import { IconRow, IconTitleSection, PageSectionContainer } from './PageSection.styles';

export const PageSection = ({ Button, title, Icon, children }) => (
  <PageSectionContainer>
    <IconRow>
      <IconTitleSection alignItems="center">
        {Icon && <Icon />}
        <h5 className="section-title">{title}</h5>
      </IconTitleSection>
      {Button && Button}
    </IconRow>
    {children}
  </PageSectionContainer>
);